'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Nav = require('react-bootstrap/lib/Nav');

var _Nav2 = _interopRequireDefault(_Nav);

var _Navbar = require('react-bootstrap/lib/Navbar');

var _Navbar2 = _interopRequireDefault(_Navbar);

var _common = require('../common');

var _constants = require('../../constants');

var _NewCaseModal = require('./modal-new-case/NewCaseModal');

var _NewCaseModal2 = _interopRequireDefault(_NewCaseModal);

var _FreeUserNavbar = require('./FreeUserNavbar');

var _FreeUserNavbar2 = _interopRequireDefault(_FreeUserNavbar);

var _AnonymousNavbar = require('./AnonymousNavbar');

var _AnonymousNavbar2 = _interopRequireDefault(_AnonymousNavbar);

var _FullUserNavbar = require('./FullUserNavbar');

var _FullUserNavbar2 = _interopRequireDefault(_FullUserNavbar);

var _GuestNavbar = require('./GuestNavbar');

var _GuestNavbar2 = _interopRequireDefault(_GuestNavbar);

var _search = require('./search');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ROUTING = _constants.AppConstants.ROUTING;
var Navbar = (_dec = (0, _mobxReact.inject)('FunderStore', 'SessionStore', 'UiStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(Navbar, _Component);

  function Navbar() {
    _classCallCheck(this, Navbar);

    return _possibleConstructorReturn(this, (Navbar.__proto__ || Object.getPrototypeOf(Navbar)).apply(this, arguments));
  }

  _createClass(Navbar, [{
    key: 'onLogoutClick',
    value: function onLogoutClick() {
      // set this so that our 'will automatically logout' feature doesn't redirect to login screen
      // let window.location handle below
      this.isManuallyLoggingOut = true;

      _reactRouter.browserHistory.push(ROUTING.logout);
    }
  }, {
    key: 'renderBrand',
    value: function renderBrand() {
      var _props = this.props,
          funderLogo = _props.FunderStore.funderLogo,
          SessionStore = _props.SessionStore,
          UiStore = _props.UiStore,
          showFunderLogo = !!funderLogo,
          linkProps = !SessionStore.isGuest && { to: '/' };


      return _react2.default.createElement(
        _Navbar2.default.Brand,
        { className: (0, _classnames2.default)({ 'funder': showFunderLogo }) },
        _react2.default.createElement(
          _common.Link,
          linkProps,
          showFunderLogo ? _react2.default.createElement('img', { src: funderLogo }) : UiStore.env !== 'prod' && _react2.default.createElement(
            'small',
            { className: 'ellipsis' },
            UiStore.env
          )
        )
      );
    }
  }, {
    key: 'renderNavAuthenticated',
    value: function renderNavAuthenticated() {
      var _props$SessionStore = this.props.SessionStore,
          isGuest = _props$SessionStore.isGuest,
          isMightyFreeUser = _props$SessionStore.isMightyFreeUser,
          userNavbarProps = { onLogoutClick: this.onLogoutClick };


      if (isGuest) {
        return _react2.default.createElement(_GuestNavbar2.default, null);
      }

      if (isMightyFreeUser) {
        return _react2.default.createElement(_FreeUserNavbar2.default, userNavbarProps);
      }

      return _react2.default.createElement(_FullUserNavbar2.default, userNavbarProps);
    }
  }, {
    key: 'renderNavContent',
    value: function renderNavContent() {
      var SessionStore = this.props.SessionStore;


      if (!SessionStore.isLoggedIn) {
        return _react2.default.createElement(_AnonymousNavbar2.default, null);
      }

      return this.renderNavAuthenticated();
    }
  }, {
    key: 'renderNavbarHeader',
    value: function renderNavbarHeader() {
      return _react2.default.createElement(
        _Navbar2.default.Header,
        null,
        this.renderBrand(),
        _react2.default.createElement(_Navbar2.default.Toggle, null),
        this.props.SessionStore.isLoggedIn && _react2.default.createElement(
          _Nav2.default,
          { id: 'navbar-search', className: 'visible-xs', pullRight: true },
          _react2.default.createElement(_search.SearchNavItem, null)
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          FunderStore = _props2.FunderStore,
          UiStore = _props2.UiStore,
          serviceTier = (0, _get3.default)(FunderStore, 'funder.mighty_service_tier', ''),
          className = (0, _classnames2.default)('env-' + UiStore.env, 'service-tier-' + serviceTier.toLowerCase());


      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            _Navbar2.default,
            { className: className, collapseOnSelect: true, fluid: true, inverse: true },
            this.renderNavbarHeader(),
            _react2.default.createElement(
              _Navbar2.default.Collapse,
              null,
              this.renderNavContent()
            )
          )
        ),
        UiStore.modals.NewCase.showing() && _react2.default.createElement(_NewCaseModal2.default, null)
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Navbar;
}(_react.Component), _class2.propTypes = {
  FunderStore: _propTypes2.default.object.isRequired,
  SessionStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = Navbar;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ROUTING, 'ROUTING', '/app/src/components/layout/Navbar.js');
  reactHotLoader.register(Navbar, 'Navbar', '/app/src/components/layout/Navbar.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/layout/Navbar.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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